import { io, Socket } from "socket.io-client";

const agency = "ACC";
const fullName = "Mr Tester";
const isAdmin = true;

export const socket = (employeeCode?: string, token?: string): Socket => {
  return io(
    `${process.env.REACT_APP_SOCKET_BASE_URL}${process.env.REACT_APP_SOCKET_PORT}`,

    {
      query: {
        username: employeeCode,
        agency,
        fullName,
        isAdmin,
      },
      extraHeaders: {
        authorization: `Bearer ${token}`,
      },
      //   autoConnect: false,
      //   transports: ["websocket"],
    },
  );
};
